import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { useEffect, useRef } from 'react';

const MarkerCluster = ({ map, markers, gridSize = 60 }) => {
  const markerClustererRef = useRef(null);

  useEffect(() => {
    if (!map || !markers.length) return;

    // Limpiar los clusters anteriores
    if (markerClustererRef.current) {
      markerClustererRef.current.clearMarkers();
    }

    markerClustererRef.current = new MarkerClusterer({
      map,
      markers,
      gridSize,
      renderer: {
        render: ({ count, position }) => {
          const svg = `
            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="45" height="45" viewBox="0 0 227 185" preserveAspectRatio="xMidYMid meet">
              <g transform="translate(0,185) scale(0.1,-0.1)" fill="#4D368A" stroke="none">
                <path d="M1049 1673 c-224 -192 -772 -673 -796 -699 -25 -25 -33 -43 -33 -70 0 -72 42 -104 139 -104 l60 0 3 -284 3 -284 30 -43 c17 -23 48 -52 70 -63 39 -20 55 -21 573 -24 371 -2 546 1 575 9 60 16 122 83 135 146 6 28 7 150 5 294 l-6 247 73 4 c67 3 75 6 101 36 36 41 39 90 7 125 -13 14 -194 175 -403 357 -209 183 -390 342 -402 352 -11 11 -39 22 -60 25 -34 4 -45 1 -74 -24z"/>
              </g>
              <text x="113.5" y="130" font-size="65" font-family="Arial" font-weight="bold" text-anchor="middle" fill="#FFFFFF">${count}</text>
            </svg>
          `;

          const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

          const marker = new window.google.maps.Marker({
            position,
            icon: {
              url,
              scaledSize: new window.google.maps.Size(45, 45),
              ariaLabel: `Cluster de ${count} propiedades`, // Añadido aria-label
            },
          });

          marker.addListener('domready', () => {
            const element = document.querySelector(`[src="${url}"]`);
            if (element) {
              element.classList.add('cluster-marker');
              element.setAttribute('role', 'button'); // Añadido role
              element.setAttribute('tabindex', '0'); // Añadido tabindex para accesibilidad
              element.setAttribute('aria-label', `Cluster de ${count} propiedades`); // Añadido aria-label para accesibilidad
            }
          });

          return marker;
        },
      },
    });

    // Limpiar los clusters al desmontar el componente
    return () => {
      if (markerClustererRef.current) {
        markerClustererRef.current.clearMarkers();
      }
    };
  }, [map, markers, gridSize]);

  return null;
};

export default MarkerCluster;
